import { Navigate, Route } from "react-router-dom";
import { List, Create, Edit } from "../components";

const supplierRoutes = [
    <Route index element={<Navigate to="list" replace />} key={"list:index"} />,
    <Route path="list" element={<List />} key={"list"} />,
    <Route path="new" element={<Create />} key={"new"} />,
    <Route path=":supplierId" element={<Edit />} key={"edit"} />,
];
export default supplierRoutes;
